import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { complaintOptionsProjection } from "../sanity/complaintOptions.projection"

export const queryComplaintAvailableDefects = {
  async complaintAvailableDefects(_parent, args, context, _info) {
    const lang = AppSettings.defaultLocale()
    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: (args.cdn = false) })

    try {
      const availableDefects = await client.fetch(groq`*[_type=="complaintAvailableDefects"] | order(name asc){
        ${complaintOptionsProjection()}
      }`)
      return availableDefects
    } catch (error) {
      throw new Error(error)
    }
  },
}
